var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.092 16.2649C10.8221 16.2685 10.5601 16.1736 10.355 15.9979C10.259 15.9181 10.1816 15.8182 10.1286 15.7052C10.0755 15.5921 10.048 15.4688 10.048 15.3439C10.048 15.219 10.0755 15.0957 10.1286 14.9827C10.1816 14.8696 10.259 14.7697 10.355 14.6899L13.792 11.6549L10.492 8.60591C10.3972 8.52622 10.3209 8.42674 10.2686 8.31445C10.2163 8.20216 10.1892 8.07979 10.1892 7.95591C10.1892 7.83204 10.2163 7.70966 10.2686 7.59737C10.3209 7.48508 10.3972 7.3856 10.492 7.30591C10.6973 7.13008 10.9587 7.03345 11.229 7.03345C11.4993 7.03345 11.7607 7.13008 11.966 7.30591L15.974 10.9909C16.0672 11.0706 16.1419 11.1695 16.1932 11.2809C16.2444 11.3922 16.271 11.5133 16.271 11.6359C16.271 11.7585 16.2444 11.8796 16.1932 11.9909C16.1419 12.1023 16.0672 12.2012 15.974 12.2809L11.821 15.9659C11.6233 16.1522 11.3636 16.2587 11.092 16.2649Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.a866f0520f9f339ac25001293b6a3c3c.svg";
export { ForwardRef as ReactComponent };